
import { defineComponent, toRefs, reactive, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router/index'
export default defineComponent({
  props: {
    searchData: {
      type: Array,
      default: () => {
        return []
      }
    },
    menu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props: any, context: any) {
    const route = useRoute()
    const pageSelect = ref()
    const pageData: any = reactive({
      value: [],
      data: [],
      options: [],
      getPopupContainer: (e: HTMLElement) => e.parentNode
    })
    watch(
      () => props.searchData,
      (newV: any) => {
        const data = newV
        data.forEach((item: any) => {
          item.value = item.meta.title
          item.label = item.meta.title
        })
        pageData.data = data
        pageData.options = data
      }
    )
    function handleSearch(a: any) {
      const data = pageData.data.filter((item: any) => {
        return item.label.indexOf(a) > -1
      })
      pageData.options = data
    }
    function handleChange(name: any) {
      context.emit('clickItem', {
        key: name,
        keyPath: [name],
        selectedKeys: [name]
      })
      pageSelect.value.blur()
      pageData.options = pageData.data
    }
    return {
      ...toRefs(pageData),
      handleSearch,
      handleChange,
      pageSelect
    }
  }
})
